import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fromEvent } from 'rxjs';
import { NetworkService } from './network.service';

@UntilDestroy()
@Directive({
    selector: '[disableOffline]',
    standalone: true
})
export class DisableOfflineDirective implements AfterViewInit, OnChanges {
  @Input() allowOffline = false;

  disabled = false;
  isOffline = false;

  constructor(
    private readonly network: NetworkService,
    private readonly elementRef: ElementRef,
    private readonly snackBar: MatSnackBar
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['allowOffline']) {
      this.disabled = this.isOffline && !this.allowOffline;
    }
  }

  ngAfterViewInit(): void {
    this.network.isOffline$
      .pipe(untilDestroyed(this))
      .subscribe((isOffline) => {
        this.isOffline = isOffline;
        this.disabled = isOffline && !this.allowOffline;
      });

    fromEvent(this.elementRef.nativeElement, 'click', {
      capture: true,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }).subscribe((e: any) => {
      if (this.disabled) {
        e.stopImmediatePropagation();
        this.snackBar.open(
          'Can not perform action offline. Please notify management or retry online.',
          undefined,
          { duration: 7000 }
        );
        return;
      }
    });
  }
}
